import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80defb98"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "home-container",
  id: "aboutEvent"
}
const _hoisted_2 = {
  key: 0,
  class: "img-container"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons icard" }, "groups", -1))
const _hoisted_5 = { class: "titulo-cards" }
const _hoisted_6 = { class: "card-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return ($setup.eventData && $setup.eventData.aboutEvent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($setup.eventData.aboutEvent.image && $setup.eventData.aboutEvent.image != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                class: _normalizeClass(["img-event", 'image-event-' + $setup.type]),
                src: $setup.eventData.aboutEvent.image,
                alt: "Event Image"
              }, null, 10, _hoisted_3)
            ]))
          : _createCommentVNode("", true),
        ($setup.eventData.aboutEvent.cards)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["cards-container", 'cards-' + $setup.type])
            }, [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.eventData.aboutEvent.cards, (card) => {
                    return _withDirectives((_openBlock(), _createBlock(_component_el_col, {
                      xs: 24,
                      sm: 24,
                      md: 10,
                      lg: 7,
                      xl: 7,
                      class: "cards",
                      key: card
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4,
                        _createElementVNode("h1", _hoisted_5, _toDisplayString(card.title), 1),
                        _createElementVNode("p", _hoisted_6, _toDisplayString(card.description), 1)
                      ]),
                      _: 2
                    }, 1024)), [
                      [_vShow, card.title != '' && card.description != '']
                    ])
                  }), 128))
                ]),
                _: 1
              })
            ], 2))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}